import React, { useContext, useState, useEffect } from "react";
import { Box, Typography, Stack, Link, Tooltip } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DashboardCard from "../DashboardCard";
import { FirebaseContext } from "App";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";

const OtherProductsCard = () => {
    const firebaseApp = useContext(FirebaseContext);
    const [courses, setCourses] = useState(null);

    useEffect(() => {
        if (firebaseApp) {
            const remoteConfig = getRemoteConfig(firebaseApp);
            remoteConfig.settings = {
                fetchTimeoutMillis: 60000, // Tempo limite para a busca
                minimumFetchIntervalMillis: 3500000, // Intervalo entre buscas no firebase (aprox. 1 hora)
            };
            fetchAndActivate(remoteConfig)
                .then(() => {
                    const configsString = getValue(
                        remoteConfig,
                        "courses",
                    ).asString();
                    if (configsString) {
                        const configs = JSON.parse(configsString);
                        setCourses(configs);
                    }
                })
                .catch((error) => {
                    console.error("Erro ao buscar ou ativar configurações:", error);
                });
        }
    }, [firebaseApp]);

    return (
        <DashboardCard title="Outros Produtos Probrain" showArrow={false}>
            <Stack direction="row" spacing={2} sx={{ overflowX: "auto", pb: 1 }}>
                {courses?.list.map((product) => (
                    <Box key={product.id} sx={{ minWidth: 180, flex: 1, backgroundColor: "#F4F7F8", borderRadius: "10px", p: "17px" }}>
                        <Link
                            href={product.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                outline: "none",
                                boxShadow: "none",
                                "&:focus": { outline: "none", boxShadow: "none" },
                                "&:focus-visible": { outline: "none", boxShadow: "none" },
                                "&::after": { display: "none" },
                                display: "block",
                            }}
                        >
                            <Box
                                component="img"
                                src={product.image}
                                alt={product.name}
                                sx={{
                                    width: "100%",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    mb: 1,
                                }}
                            />
                        </Link>

                        <Typography
                            fontFamily="Montserrat"
                            fontWeight={600}
                            fontSize="16px"
                            letterSpacing="0.21px"
                            color="#333333"
                            mb={0.5}
                        >
                            {product.name}
                        </Typography>

                        <Tooltip title={product.description} placement="top">
                            <Typography
                                fontFamily="Montserrat"
                                fontWeight={500}
                                fontSize="14px"
                                color="#939393"
                                mb={1}

                                sx={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                }}
                            >
                                {product.description}
                            </Typography>
                        </Tooltip>


                        <Link
                            href={product.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                color: "#0A5CEA",
                                fontFamily: "Montserrat",
                                fontWeight: 500,
                                fontSize: "16px",
                                "&:hover": { opacity: 0.8 },
                                outline: "none",
                                boxShadow: "none",
                                "&:focus": { outline: "none", boxShadow: "none" },
                                "&:focus-visible": { outline: "none", boxShadow: "none" },
                                "&::after": { display: "none" },
                                display: "block",
                            }}
                        >
                            {product.label}
                            <ArrowForwardIcon sx={{ fontSize: "16px" }} />
                        </Link>
                    </Box>
                ))}
            </Stack>
        </DashboardCard>
    )
}

export default OtherProductsCard;